import {Component, Input, ViewEncapsulation} from '@angular/core';
import {SolverRunOutput} from '../solver-runner/solver-runner.component';
import {SignificantNumberPipe} from "../../shared/pipes";
import {CommonModule} from "@angular/common";

@Component({
    selector: 'solver-data-table',
    templateUrl: './solver-data-table.component.html',
    styleUrls: ['./solver-data-table.component.less'],
    imports: [
        SignificantNumberPipe,
        CommonModule
    ],
    encapsulation: ViewEncapsulation.None
})
export class SolverDataTableComponent {
    private _data: SolverRunOutput;
    @Input() set data(data: SolverRunOutput) {
        this._data = data;
    }

    get data(): SolverRunOutput {
        return this._data;
    }
}
